import { render, staticRenderFns } from "./HoldingDetalle.vue?vue&type=template&id=f9baa614"
import script from "./HoldingDetalle.vue?vue&type=script&lang=js"
export * from "./HoldingDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports